import { z } from "zod";

export const CASE_TYPES = ["REPORT_AD", "CONTACT", "INSURANCE"] as const;

export type CaseType = (typeof CASE_TYPES)[number];

export const CASE_SCHEMA = z.object({
  type: z.enum(CASE_TYPES),
  key: z.string().min(1, "Key is required"),
  userId: z.string(),
  deviceId: z.string(),
});

export type Case = z.infer<typeof CASE_SCHEMA>;
